export default __webpack_public_path__ + "static/media/audible.81f05998.png";